import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useApi from "../hooks/useApi";
import ThreeViewer from "../components/ThreeViewer";
import running from "../animations/Running.fbx";
import Dropdown from "../components/DropdownAnimation";
import PromptInputs from "../components/PromptInputs";
import DropdownCharacterList from "../components/DropdownCharacterList";
import StatusVariantIndicator from "../components/StatusVariantIndicator";
import useCharacter from "../hooks/useCharacter";

import styles from "../styles/CharacterView.module.css";
import common from "../styles/Common.module.css";
import { useDispatch } from "react-redux";
import { start3DCharacterPolling } from "../reducers/characterSlice";
import LoraImagesGrid from "../components/LoraImagesGrid";
import { addModal, showLoading, closeAllModals } from "../reducers/modalsSlice";
import { addNotification } from "../reducers/notificationsSlice";

const CharacterVariant = () => {
	const { id, index } = useParams();
	const {get} = useApi();

	const [loading, setLoading] = useState(true);
	const [variant, setVariant] = useState(null);
	const [workflow, setWorkflow] = useState(null);
	const [character, setCharacter] = useState(null);
	const [prompt, setPrompt] = useState("");
	const [loraPrompt, setLoraPrompt] = useState("");
	const [robloxName, setRobloxName] = useState("");
	const [modelURL, setModelURL] = useState(null);

	const viewerRef = useRef(null);
	const recordingAnimationRef = useRef(0);
	const recordingAnimationFramesRef = useRef([]);

	const [dataset, setDataset] = useState([]);
	const [animations, setAnimations] = useState([]);
	const [recordingAnimations, setRecordignAnimations] = useState([]);
	const [recording, setRecording] = useState(false);
	const [showingLoraGrid, setShowingLoraGrid] = useState(false);

	const navigate = useNavigate();
	const dispatch = useDispatch();


	const {
		GenerateModelFromVariant,
	  } = useCharacter();
	
	useEffect(() => {
		const getAnimations = async () => {
			const response = await get(`/webapp/animations/`);
			setAnimations(response);
		};
		const getCharacter = async (character_id) => {
			try {
			  const response = await get(
				`/webapp/characters/3d/${character_id}/`
			  );
			  
			  setCharacter(response);
			  
			  console.log(response.processing);
			//   while(!viewerRef.current){}

			  if (response.processing) {
				if (
					response.model_glb !== undefined &&
					response.model_glb !== null
				) {
					// LoadModel(response.model_glb);
					setModelURL(response.model_glb)
				}
	  
			  } else {
				  if(response.model_vrm){
					if(response.roblox_asset_id !== ""){
						// show glb for roblox models
						setModelURL(response.model_glb);
					}else{
						setModelURL(response.model_vrm);
					}
				  }else if(response.model_glb !== ""){
					  setModelURL(response.model_glb);
				  }
				// LoadModel(response.model_vrm);
			  }
			} catch (error) {
			  console.error("Error fetching character:", error);
			}
		};
		  
		const getVariant = async () => {
			const response = await get(`/webapp/characters/2d/${id}/`);
			let variantData = response.variants[0][`variant_${index}`];
			
			variantData = {...variantData, part: response.variants[0].part};
			// console.log(response)
			// console.log(variantData)

			setVariant(variantData);
			setWorkflow(response.workflow);
			
			if(variantData.character.id){
				getCharacter(variantData.character.id);
			}
		};

		getVariant();
		getAnimations();

	}, []);

	const handleGenerateModelAndRig = async () => {
		if(robloxName === "" && (workflow === 'playgen-accessory-side' || workflow === 'playgen-accessory-front')){
			dispatch(addModal({ 
				message: "Please enter a product name", 
				type: "confirm",
				onConfirm: ()=> { dispatch(closeAllModals()); }}
			));
			return;
		}
		const onConfirm = async () => {
			dispatch(showLoading());
			const response = await GenerateModelFromVariant(
				variant.id,
				index,
				robloxName
			);
				
			if (response.id != null) {
				dispatch(start3DCharacterPolling({ id: response.id, get }));
				navigate(-1);
			}else{
				dispatch(addNotification({message: "something went wrong"}));
			}

			dispatch(closeAllModals());
		}
	
		dispatch(addModal({ 
			message: "This requires 10 amount of credits. Proceed?", 
			type: "confirm",
			onConfirm: onConfirm
		}));		
	  };
	
	// const LoadModel = (url) => {
	// 	console.log("loadmodel", viewerRef.current, url)
	// 	if (viewerRef.current) {
	// 		console.log(url)
	// 		viewerRef.current.loadModel(url);
	// 		// viewerRef.current.loadModel("https://d1liq7a4zwjwim.cloudfront.net/3ff81d08-43a2-41c3-84cb-7306e0960c5c/data/output.vrm");
	// 	}
	// };

	const selectAnimation = (animation) => {
    if (viewerRef.current) {
      viewerRef.current.playAnimation(animation);
    }
  };

  const onAnimationRecorded = () => {
    console.log('animation ended', recordingAnimationRef.current, recordingAnimations.length)
    if(recordingAnimationRef.current < recordingAnimations.length-1){
      // record next animation
      recordingAnimationRef.current++;
      recordAnimation();
    }else{
      // record finished
      setRecording(false);
      viewerRef.current.playAnimation(running);
      setDataset(recordingAnimationFramesRef.current);
    }
  }

  const recordAnimation = () => {
    const anim = recordingAnimations[recordingAnimationRef.current];
    if(anim.selected){
      console.log(`recording ${anim.name}`);
      viewerRef.current.recordAnimation(character.model_vrm, anim.fbx, 
        (frame, dataURL) => {
          // console.log("process frame")
          recordingAnimationFramesRef.current.push({animation: anim, frame:frame, dataURL:dataURL});
        }, onAnimationRecorded);
    }else{
      console.log(`skipping ${anim.name}`);
      onAnimationRecorded();
    }
  }

  useEffect(() => {
    if(recordingAnimations.length > 0){
      console.log(recordingAnimations);
      // setRecordingAnimation(animations[0]);
      // setRecording(true);
      if (viewerRef.current) {
        setDataset([]);
        setRecordignAnimations([]);
        recordingAnimationRef.current = 0;
        recordingAnimationFramesRef.current = [];
        recordAnimation();
      }
    }
  }, [recordingAnimations]);
    
  const startRecording = (anims) => {
    setRecording(true);
    setRecordignAnimations(anims);
  };

  const clearDataset = () => {
    setDataset([]);
  }

  
  const downloadVRM = () => {
    //Metodo 1
    const link = document.createElement("a");
    link.href = character.model_vrm;
    link.download = `${character.name}.vrm`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    //Metodo 2
    // if (viewerRef.current) {
    // viewerRef.current.downloadVRM();
    // }
  };

	const downloadGLB = () => {
		const link = document.createElement("a");
		link.href = character.model_glb;
		link.download = `${character.name}.vrm`;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	const openInRoblox = () => {
		// window.open(`https://create.roblox.com/store/asset/${character.roblox_asset_id}`)
		window.open(`https://www.roblox.com/games/138820349388482/PlayGen`)
	}

	const copyVrmUrl = async () => {
		try {
			await navigator.clipboard.writeText(character.model_vrm);
			alert("¡URL copied to clipboard!");
		} catch (error) {
			console.error("Error al copiar la URL:", error);
		}
	};

	const updateMenu = (menuIndex) => {
		setShowingLoraGrid(menuIndex === 4);
	}

	console.log(character)

	return <div className={styles.appContent}>
		<PromptInputs
			// menuIndex={midMenu}
			updateMenu={updateMenu}
			character={character}
			variant={variant}
			variant_index={index}
			prompt={prompt}
			externalLoraPrompt={loraPrompt}
			updateAnimation={selectAnimation}
			startRecording={startRecording}
			dataset={dataset}
			animations={animations}
			loading={loading}
			recording={recording}
			clearDataset={clearDataset}
		/>

		<div className={styles.midMenu}>
				
			{character?.has_3d && !showingLoraGrid &&
				<div className={styles.view3d}>
					<div className={styles.container}>
						<div className={styles.preview}>
							{loading ? (
								<div className={styles.loadingIndicator}>
								<div className={styles.loader}></div>
								</div>
							) : null}
							
							<ThreeViewer
								ref={viewerRef}
								defaultAnimation={running}
								loadState={setLoading}
								url={modelURL}
								/>
						</div>
				
						{!loading && (
							<div className={styles.controls}>

								{character.model_vrm !== "" && character.roblox_asset_id !== "" && character.model_vrm?.endsWith("glb") && (
									<>
										<button className={styles.bottomMenu} onClick={downloadGLB}>Download GLB</button>
									</>
								)}

								{character.model_vrm !== "" && character.model_vrm?.endsWith("vrm") && (
									<>
										<Dropdown onSelect={selectAnimation} animations={animations} />
										<button onClick={downloadVRM}>Download VRM</button>
										<button onClick={copyVrmUrl}>Copy VRM Url</button>
									</>
								)}
								{character.model_vrm !== "" && character.roblox_user_id !== "" && (
									<button className={common.primaryButton} onClick={openInRoblox}>Open in Roblox</button>
								)}
							</div>
						)}
					</div>
					
				</div>
			}

			{character === null && variant !== null &&
				<>
					<div className={styles.view2d}>
						{/* <button onClick={returnToVariants}>back</button> */}
						<div className={styles.container}>
							<div className={styles.preview}>
								<img src={variant?.url} />
								<StatusVariantIndicator character={variant.character} />
							</div>
						</div>
					</div>
					{(workflow === 'runpod-2d' || workflow === 'very_simpl_tpose_w_alpha2') &&
						// 3d character
						<div className={common.buttonBar}>
							<button
								className={common.generateButton}
								onClick={handleGenerateModelAndRig}
								>
								Model and Autorig (O 10 credits)
							</button>
						</div>
					}
					{(workflow === 'playgen-accessory-side' || workflow === 'playgen-accessory-front') &&
						// Roblox Asset
						<div className={common.buttonBar}>
							<input className={styles.productName} type="text" placeholder="Product Name" 
									value={robloxName} onChange={(e) => setRobloxName(e.currentTarget.value)}></input>
							<button
								className={common.generateButton}
								onClick={handleGenerateModelAndRig}
								>
								Send To Roblox (O 10 credits)
							</button>
						</div>
						
					}
				</>
			}

			{showingLoraGrid &&
				<LoraImagesGrid id={id} index={index} onLoraImageselected={(image) => {
					setLoraPrompt(image.prompt)
				}} />
			}



		</div>
		
		<DropdownCharacterList />

	</div> 
	
};

export default CharacterVariant;
